/**
 * Masks a phone number input by inserting dashes at specific positions.
 *
 * @param value - The phone number to be masked.
 * @returns The masked phone number.
 */
const maskPhoneInput = (value: string): string => {
  const numbers = value.replace(/\D/g, '');
  const char: { [key: number]: string } = { 3: '-', 6: '-', 10: ' x' };
  let mask = '';
  for (let i = 0; i < numbers.length; i++) {
    mask += (char[i] || '') + numbers[i];
  }
  return mask;
};

export default maskPhoneInput;
